import JamIcon from '../JamIcon';
import { useTranslation } from 'react-i18next';
import { SMuiButton } from './styled';

export default function FilterButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <SMuiButton
      onClick={onClick}
      startIcon={<JamIcon icon="settings-alt" color="inherit" />}
    >
      {t('Filter')}
    </SMuiButton>
  );
}
